module.exports = __webpack_public_path__ + "img/ac59ff5.webp";